export const LANGUAGES = [
    { label: "All", value: "all" },
    { label: "English", value: "en" },
    { label: "Telugu", value: "te" },
    { label: "Hindi", value: "hi" },
    { label: "Tamil", value: "ta" },
    { label: "Malayalam", value: "ml" },
    { label: "Kannada", value: "kn" },
  ];
  